import React, {
  memo,
  useCallback,
  // useEffect,
  useState,
} from 'react';
import { useHistory, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';

import { LOCATIONS } from 'constants/index';

import AppButton from 'components/App/Button';
import { ReactComponent as VpnKeyIcon } from 'assets/images/vpnkey.svg';
import userIcon from 'assets/images/user-icon.svg';

import styles from './ExtranetProfileMenu.module.scss';

const ExtranetProfileMenu = (props) => {
  const {
    loading,
    me,
    actionLogout,
  } = props;

  const history = useHistory();
  const [menu, setMenu] = useState(false);

  const onToggle = useCallback(() => {
    setMenu((prevState) => !prevState);
  }, []);

  const onLogout = useCallback(() => {
    actionLogout({ history });
  }, [actionLogout, history]);

  if (loading) {
    return <AppButton loading={loading} color="light" />;
  }

  return (
    <Dropdown isOpen={menu} toggle={onToggle} className="d-inline-flex align-items-center">
      <DropdownToggle
        className={styles.ProfileToggle}
        id="extranet-header-user-dropdown"
        tag="button"
      >
        <img src={userIcon} alt="user" />
        <span>{me.fullName}</span>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <Link to={LOCATIONS.CHANGE_PASSWORD} className="dropdown-item">
          <VpnKeyIcon className="align-middle me-2" />
          <span>Thay đổi mật khẩu</span>
        </Link>

        <button type="button" onClick={onLogout} className="dropdown-item text-danger">
          <i className="bx bx-log-out font-size-16 align-middle me-2" />
          <span>Đăng xuất</span>
        </button>
      </DropdownMenu>
    </Dropdown>
  );
};

ExtranetProfileMenu.propTypes = {
  loading: PropTypes.bool.isRequired,
  me: PropTypes.instanceOf(Object).isRequired,
  actionLogout: PropTypes.func,
};

ExtranetProfileMenu.defaultProps = {
  actionLogout: () => {},
};

export default memo(ExtranetProfileMenu);
